angular.module('dpw.directives')
    .component('dpwPrimaryNav', {
        bindings: {},
        templateUrl: 'dpw-primary-nav.html',
        controller: ['$window', 'helpers', 'menuService', function ($window, helpers, menuService) {
            var self = this;

            Object.defineProperty(self, 'items', {
                get: function () {
                    return menuService.getPrimaryItems();
                }
            })

            self.shouldItemDisplay = function (menuItem) {
                return angular.isFunction(menuItem.display) ?
                    menuItem.display() :
                    menuItem.display !== false;
            };

            self.getItemClassNames = function (menuItem) {
                return menuService
                    .getClassNamesBaseOn(menuItem.text, 'dpw-menu-item')
                    .concat(self.isItemActive(menuItem) ? 'dpw-menu-item-active' : '')
                    .concat(menuItem.secondary && menuItem.isPanelVisible ? 'dpw-menu-item-panel-visible' : '');
            };

            self.onItemClick = function (menuItem, $event) {
                menuService.onItemClick(menuItem, $event);
            };

            self.showItemPanel = function (menuItem) {
                menuItem.isPanelVisible = true;
            };

            self.hideItemPanel = function (menuItem, $event) {
                // @see DPW-15146
                if ($event.target && $event.target.nodeName.toLowerCase() === 'select') {
                    return;
                }

                menuItem.isPanelVisible = false;
            };

            self.isItemActive = function (menuItem) {
                var pathname = $window.location.pathname;

                return menuItem.isPanelVisible ||
                    menuItem.href === pathname ||
                    menuService.hasActivateChild(menuItem, pathname);
            };
        }]
    });
